import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "goods-box"
};
const _hoisted_2 = {
    class: "item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_image = _resolveComponent("el-image");
    const _component_el_icon_circle_close_filled = _resolveComponent("el-icon-circle-close-filled");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_draggable = _resolveComponent("draggable");
    const _component_el_icon_plus = _resolveComponent("el-icon-plus");
    const _component_Goods = _resolveComponent("Goods");
    return _openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_draggable, {
                class: "list-group",
                group: {
                    name: 'imageList',
                    pull: false,
                    put: false
                },
                "item-key": "id",
                modelValue: $data.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.value = $event),
                animation: 340
            }, {
                item: _withCtx(({ element, index })=>[
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_el_image, {
                                style: {
                                    "width": "100%",
                                    "height": "100%"
                                },
                                src: element.image,
                                "initial-index": index,
                                "preview-src-list": $options.previewSrcList,
                                fit: "cover"
                            }, null, 8, [
                                "src",
                                "initial-index",
                                "preview-src-list"
                            ]),
                            _createVNode(_component_el_icon, {
                                class: "delete",
                                onClick: ($event)=>$options.deleteData(index)
                            }, {
                                default: _withCtx(()=>[
                                        _createVNode(_component_el_icon_circle_close_filled)
                                    ]),
                                _: 1
                            }, 8, [
                                "onClick"
                            ])
                        ])
                    ]),
                _: 1
            }, 8, [
                "modelValue"
            ]),
            _createElementVNode("div", {
                class: "add-item item",
                onClick: _cache[1] || (_cache[1] = (...args)=>$options.choose && $options.choose(...args))
            }, [
                _createVNode(_component_el_icon, null, {
                    default: _withCtx(()=>[
                            _createVNode(_component_el_icon_plus)
                        ]),
                    _: 1
                })
            ])
        ]),
        $data.dialog.save ? (_openBlock(), _createBlock(_component_Goods, {
            key: 0,
            ref: "GoodsDialog",
            onSuccess: $options.handleSuccess,
            onClosed: _cache[2] || (_cache[2] = ($event)=>$data.dialog.save = false)
        }, null, 8, [
            "onSuccess"
        ])) : _createCommentVNode("", true)
    ], 64);
}
